import { ProductActionType } from '../actions/types';

type State =
  | {
      campaigns: any[] | null;
      variantSizes: string[] | null;
      condition: string;
    }
  | undefined;

type Action =
  | {
      type: ProductActionType.CAMPAIGNS_RECEIVE;
      campaigns: any[] | null;
    }
  | {
      type: ProductActionType.ROUTE_LOADED;
      location: Location;
      data: any;
      errors: any;
    };

export const defaultProductState = {
  campaigns: null,
  variantSizes: null,
  condition: 'new',
};

export default (state: State, action: Action) => {
  if (!state) {
    return defaultProductState;
  }

  switch (action.type) {
    case ProductActionType.CAMPAIGNS_RECEIVE: {
      return {
        ...state,
        campaigns:
          action.campaigns &&
          action.campaigns.filter(campaign => campaign.state === 'ACTIVE'),
      };
    }

    default:
      return state;
  }
};
